// extracted by mini-css-extract-plugin
export var definitionList = "definitionList-module--definitionList--b7e73";
export var wrapper = "definitionList-module--wrapper--63300";